import { render, staticRenderFns } from "./LabElementIndex.vue?vue&type=template&id=a471789a"
import script from "./LabElementIndex.vue?vue&type=script&lang=js"
export * from "./LabElementIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports